// AUTO-GENERATED FILE - DO NOT EDIT
// Generated by scripts/generate-cube-meta.ts
import type {
  CubeMeasureEntry,
  CubeDimensionEntry,
  CubeJoinEntry
} from 'shared/src/api/cube-api-types';

export const notesCubeMeta = {
  name: 'notes',
  title: 'Notes',
  joins: {
    campaigns: { relationship: 'many_to_one' } as const satisfies CubeJoinEntry
  },
  measures: {
    'notes.count': {
      type: 'number',
      aggType: 'count',
      title: 'Note Count',
      description: 'Number of notes',
      meta: {
        category: 'utility',
        supports_rollup: true,
        formula: 'COUNT(*)',
        inputs: [],
        short_description: 'Number of notes',
        source_tables: ['media_tool.notes']
      }
    } as const satisfies CubeMeasureEntry
  },
  dimensions: {
    'notes.id': {
      sql: 'id',
      type: 'string',
      title: 'Note ID',
      primaryKey: true,
      meta: {
        short_description: 'Zoho CRM Note ID',
        source_tables: ['media_tool.notes']
      }
    } as const satisfies CubeDimensionEntry,
    'notes.owner_id': {
      sql: 'owner_id',
      type: 'string',
      title: 'Owner ID',
      meta: {
        short_description: 'Zoho user ID of the note owner',
        source_tables: ['media_tool.notes']
      }
    } as const satisfies CubeDimensionEntry,
    'notes.note_content': {
      sql: 'note_content',
      type: 'string',
      title: 'Note Content',
      meta: {
        short_description: 'Full text content of the note',
        source_tables: ['media_tool.notes']
      }
    } as const satisfies CubeDimensionEntry,
    'notes.note_type': {
      sql: 'note_type',
      type: 'string',
      title: 'Note Type',
      meta: {
        short_description: 'Type classification of the note',
        source_tables: ['media_tool.notes']
      }
    } as const satisfies CubeDimensionEntry,
    'notes.parent_id': {
      sql: 'parent_id',
      type: 'string',
      title: 'Parent ID',
      meta: {
        short_description: 'ID of the parent record (campaign/deal)',
        source_tables: ['media_tool.notes']
      }
    } as const satisfies CubeDimensionEntry,
    'notes.parent_type': {
      sql: 'parent_type',
      type: 'string',
      title: 'Parent Type',
      meta: {
        short_description: 'Type of parent record (filtered to Deals)',
        source_tables: ['media_tool.notes']
      }
    } as const satisfies CubeDimensionEntry,
    'notes.note_title': {
      sql: 'note_title',
      type: 'string',
      title: 'Note Title',
      meta: {
        short_description: 'Title of the note',
        source_tables: ['media_tool.notes']
      }
    } as const satisfies CubeDimensionEntry,
    'notes.created_by': {
      sql: 'created_by',
      type: 'string',
      title: 'Created By',
      meta: {
        short_description: 'Zoho user who created the note',
        source_tables: ['media_tool.notes']
      }
    } as const satisfies CubeDimensionEntry,
    'notes.created_time': {
      sql: 'created_time',
      type: 'time',
      title: 'Created Time',
      meta: {
        short_description: 'Timestamp when the note was created',
        source_tables: ['media_tool.notes']
      }
    } as const satisfies CubeDimensionEntry,
    'notes.modified_by': {
      sql: 'modified_by',
      type: 'string',
      title: 'Modified By',
      meta: {
        short_description: 'Zoho user who last modified the note',
        source_tables: ['media_tool.notes']
      }
    } as const satisfies CubeDimensionEntry,
    'notes.modified_time': {
      sql: 'modified_time',
      type: 'time',
      title: 'Modified Time',
      meta: {
        short_description: 'Last modified timestamp from Zoho CRM',
        source_tables: ['media_tool.notes']
      }
    } as const satisfies CubeDimensionEntry,
    'notes.associated_id': {
      sql: 'associated_id',
      type: 'string',
      title: 'Associated ID',
      meta: {
        short_description: 'ID of the associated record',
        source_tables: ['media_tool.notes']
      }
    } as const satisfies CubeDimensionEntry
  }
};
